module.exports = __webpack_public_path__ + "img/MCD1000_1-1.3701b7f3.jpg";